import createAuth0Client from '@auth0/auth0-spa-js';

const auth = async function (domain, client_id, redirect_uri, audience) {
  const auth0Client = await createAuth0Client({
    domain,
    client_id,
    redirect_uri,
    cacheLocation: 'localstorage',
    audience: audience || 'transport-load-board', // ensure audience is always present because there are times it's undefined - need to investigate cause
  });

  return auth0Client;
};

export default auth;
